<template>
  <div class="charts" style="width: 100%; height: 100%"></div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import defaultsdeep from 'lodash.defaultsdeep'
export default {
  name: 'LineCharts',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    lineColor: {
      type: String,
      default: '#ccc'
    },
    colorStops: {
      type: Array,
      default() {
        return []
      }
    },
    xAxisData: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    data() {
      this.createCharts()
    }
  },
  mounted() {
    this.createCharts()
  },
  methods: {
    createCharts() {
      if (!this.Chart) this.Chart = echarts.init(this.$el)
      this.Chart.setOption(
        defaultsdeep(
          {},
          {
            tooltip: {
              trigger: 'axis',
              confine: true,
              axisPointer: {
                lineStyle: {}
              },
              backgroundColor:
                'linear-gradient(-135deg, #FF8787 0%, #B04FFF 100%)',
              position: function(pt) {
                return [pt[0], '10%']
              }
            },

            grid: {
              left: '0%',
              right: '2%',
              top: '10%',
              bottom: '0%',
              containLabel: true
            },

            xAxis: {
              type: 'category',
              boundaryGap: false,
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: 'rgba(0,0,0,0.65)',
                // interval: Math.round(self.score.date.length / 10 - 1),
                fontSize: 12,
                rotate: 270
              },
              data: this.xAxisData
            },

            yAxis: {
              type: 'value',
              boundaryGap: [0, '100%'],
              scale: true,
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisLine: {
                show: false
              },
              max: 25,
              axisLabel: {
                color: 'rgba(0,0,0,0.65)',
                formatter: function(value, index) {
                  const starNum = value / 5
                  switch (starNum) {
                    case 1:
                      return '一星'
                    case 2:
                      return '二星'
                    case 3:
                      return '三星'
                    case 4:
                      return '四星'
                    case 5:
                      return '五星'
                  }
                }
              }
            },

            dataZoom: [
              {
                type: 'inside',
                disabled: true
              }
            ],

            series: [
              {
                type: 'line',
                smooth: true,
                showSymbol: false,
                hoverAnimation: true,
                data: this.data,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x2: 0,
                    y2: 1,
                    colorStops: this.colorStops,
                    globalCoord: false // 缺省为 false
                  }
                },
                lineStyle: {
                  color: this.lineColor
                },
                itemStyle: {
                  color: 'rgba(65, 166, 255, 1)'
                }
              }
            ]
          },
          this.option
        )
      )
    }
  }
}
</script>
